// extracted by mini-css-extract-plugin
export default {"timeWeekSummary":"TimeWeekSummary_timeWeekSummary__hyAs2"};